import { render, staticRenderFns } from "./VDataTableSessions.vue?vue&type=template&id=1d26d10b&scoped=true"
import script from "./VDataTableSessions.vue?vue&type=script&lang=js"
export * from "./VDataTableSessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d26d10b",
  null
  
)

export default component.exports